import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Spinner from 'components/Spinner/desktop';

import useGiftRequests from 'features/bonusProgram/model/useGiftRequests';
import { checkBonusPromoAllowed } from 'features/bonusProgram/data';

import GiftRequestsFilter from './GiftRequestsFilter';
import GiftRequestsTable from './GiftRequestsTable';
import './GiftRequests.scss';

const b = block('gifts-requests-desktop');

const GiftRequests = () => {
  const actionProcessing = useSelector(s => s.bonusProgram.actionProcessing);
  const model = useGiftRequests();
  const authData = useSelector(s => s.auth);
  if (!checkBonusPromoAllowed(authData)) return null;

  return (
    <article className={b()}>
      <Spinner isLoading={actionProcessing} />
      <GiftRequestsFilter model={model} />
      <GiftRequestsTable model={model} />
    </article>
  );
};

export default GiftRequests;
